<form #inputForm>
    <mat-form-field>
        <mat-label>Upload Logo</mat-label>
        <mat-icon matSuffix matTooltip="Choose file..." (click)="fileInput.click()" *ngIf="!files || files.length <= 0">
            attach_file
        </mat-icon>
        <input matInput readonly [formControl]="control" [value]="getFilesName()" (click)="fileInput.click()" [required]="required" />
        <mat-icon matSuffix class="close-icon" matTooltip="Remove file" *ngIf="files && files.length > 0" (click)="resetForm()">
            close
        </mat-icon>
        <input
            hidden
            type="file"
            (change)="onSelectFiles($event)"
            #fileInput
            [multiple]="multipleFilesAccepted"
            accept=".jpg, .jpeg, .png" />
        <mat-error *ngIf="required && control.errors?.required">Please select a file to upload</mat-error>
    </mat-form-field>
</form>
